import { mainFeatureSearch } from './mainFeatureSearch';

export default function mainSlideshow() {
  const widgetName = 'mainSlideshow';
  const widgetOpts = mainSlideshowOpts;
  const $widget = $(`#${widgetName}`);

  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $widget.html(swiperContainers);
      initSwiper(widgetName, response.Slides);
      mainFeatureSearch($widget);
    } else {
      $('.mainSlideshow-wrapper').remove();
    }
  });
}

// ------------------------------
// ------------------------------
// Swiper Initialization
function initSwiper(widget, widgetData) {
  const swiperWidgetImagesWrapper = $(`#${widget} .swiper-container-images .swiper-wrapper`);

  for (const slide of widgetData) {
    swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
  }

  if (widgetData.length == 1) {
    $(`#${widget} .mobile-view`).addClass('single-slide');
  }

  const swiperWidgetImages = new Swiper(`#${widget} .swiper-container-images`, {
    speed: 600,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    loop: widgetData.length > 1,
    watchOverflow: true,
    spaceBetween: 0,
    centeredSlides: false,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 1,
    },
    a11y: true,
    autoHeight: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: `#${widget} .swiper-button-next`,
      prevEl: `#${widget} .swiper-button-prev`,
    },
    pagination: {
      el: `#${widget} .swiper-pagination`,
      clickable: true,
    },
  });

  return swiperWidgetImages;
}

// ------------------------------
// Swiper container structure
const swiperContainers = `
    <div class="swiper-container swiper-container-images">
      <div class="swiper-wrapper"></div>
      <div class="arrows-container mobile-view">
        <div class="swiper-button-prev"></div>
        <div class="search-wrapper"></div>
        <div class="swiper-button-next"></div>
      </div>
      <div class="arrows-container desktop-view">
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  `;

// ------------------------------
// Slide Template - Images
function buildSlideTemplateImages(slide) {
  const { ImageWithPath, ImageAlternateText } = slide;

  const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${ImageWithPath}" aria-label="${ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;

  return template;
}
